import axiosInstance from "@/api/axiosInstance";
import {
  RecheckEnrollmentCoverageRequest,
  RecheckEnrollmentCoverageResponse,
} from "./types";

export const recheckEnrollmentCoverage = async (
  requestData: RecheckEnrollmentCoverageRequest,
): Promise<RecheckEnrollmentCoverageResponse> => {
  const url = `/api/private/enrollments/${requestData.enrollmentId}/recheck-coverage`;

  const response = await axiosInstance.post<RecheckEnrollmentCoverageResponse>(
    url,
    {},
  );

  return response.data;
};
